/**
 * Return whether the "includesNoData" flag has been sent in via the props.
 *
 * In this sense, "noData" means when you want to create a single hidden
 * basket item that represents an estimate or the user having no data to supply.
 */

import type { RootState } from '/business/shared/state/store';
import type { Step1SelectorProps } from '/business/shared/state/selectors/types';

export default (_state: RootState, ownProps: Step1SelectorProps | null = null): boolean =>
  ownProps?.includesNoData || false;
